import { render, staticRenderFns } from "./SidePanelNewConfiguration.vue?vue&type=template&id=73958f6f&scoped=true&"
import script from "./SidePanelNewConfiguration.vue?vue&type=script&lang=js&"
export * from "./SidePanelNewConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73958f6f",
  null
  
)

export default component.exports